import styled, { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./utils/Theme";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ClerkProvider, SignedIn, SignedOut } from "@clerk/clerk-react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import CreatePost from "./pages/CreatePost";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import AuthListener from "./components/AuthListener";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background: ${({ theme }) => theme.bg};
  color: ${({ theme }) => theme.text_primary};
  overflow-x: hidden;
  overflow-y: hidden;
  transition: all 0.2s ease;
`;

const Wrapper = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 3;
`;

// Replace with your Clerk publishable key
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || "pk_test_your_key_here";

// For development, we'll use a placeholder if no key is provided
if (!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY) {
  console.warn("⚠️  Clerk Publishable Key not found. Please add REACT_APP_CLERK_PUBLISHABLE_KEY to your .env file");
}

function App() {
  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <AuthListener />
      <ThemeProvider theme={darkTheme}>
        <Container>
          <Wrapper>
            <BrowserRouter>
              <Navbar />
              <Routes>
                <Route path="/" exact element={<Home />} />
                <Route path="/sign-in" exact element={<SignIn />} />
                <Route path="/sign-up" exact element={<SignUp />} />
                <Route 
                  path="/post" 
                  exact 
                  element={
                    <>
                      <SignedIn>
                        <CreatePost />
                      </SignedIn>
                      <SignedOut>
                        <SignIn />
                      </SignedOut>
                    </>
                  } 
                />
              </Routes>
            </BrowserRouter>
          </Wrapper>
        </Container>
      </ThemeProvider>
    </ClerkProvider>
  );
}

export default App;
